import React, { useContext } from 'react';

/**
 * Manage tab index between components without worrying about "drilling holes" with props.
 * e.g. MVC TS can tell a PropertyGrid to use a certain tab index, all nested editors
 * can use it, no matter how deeply nested they are.
 */
export interface ITabbingContext {
  /**
   * To base component tab indexes on.
   */
  tabIndex: number;
}

export const TabbingContext = React.createContext<ITabbingContext>({
  tabIndex: 0,
});

/**
 * Helper function that allows a tab index provided by props to trump
 * one that comes from the context
 */
export function getTabIndex(context: ITabbingContext, propsTabIndex?: number) {
  const { tabIndex: contextTabIndex } = context;
  return propsTabIndex ? propsTabIndex : contextTabIndex;
}

/**
 * A reusable hook to make `TabbingContext` easier to use for most cases.
 * In cases where
 * @param propsTabIndex tab index from props
 */
export function useTabbingContext(propsTabIndex?: number) {
  const context = useContext(TabbingContext);
  return getTabIndex(context, propsTabIndex);
}
